module.exports = __webpack_public_path__ + "media/images/wfc/logo-white-77c7b4883be22861f7262df48bba6f79.png";